/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
